import { Sparkles } from "lucide-react";

const FAMILY_IMG =
  "/img/twsym6bn.webp";

const RED = "#D41F30";

export default function FamilyBanner({ testId = "family-banner" }) {
  return (
    <section className="py-20 md:py-28 bg-white" data-testid={testId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="relative overflow-hidden rounded-[2.5rem] shadow-2xl bg-gray-900">
          {/* Background image */}
          <img
            src={FAMILY_IMG}
            alt="Happy family in front of their new home"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />

          {/* Gradient overlay for text legibility */}
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(90deg, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.55) 45%, rgba(0,0,0,0.05) 80%, rgba(0,0,0,0) 100%)",
            }}
          />

          <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 items-center px-7 sm:px-10 md:px-16 py-16 md:py-24 min-h-[420px] md:min-h-[520px]">
            <div className="text-white">
              <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
                <Sparkles className="w-4 h-4" style={{ color: "#fff" }} />
                <span className="text-xs font-bold tracking-[0.18em] uppercase text-white">
                  Real Families. Real Homes.
                </span>
              </div>

              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight mb-6">
                More than a house.
                <span className="block" style={{ color: "#FCA5A5" }}>
                  A home you grow into.
                </span>
              </h2>

              <p className="text-base md:text-lg text-white/85 leading-relaxed max-w-xl mb-8">
                Every family we work with is building something bigger than a transaction. CityWorth makes homeownership a real, repeatable milestone, not a once-in-a-lifetime maze.
              </p>

              <div className="grid grid-cols-3 gap-6 max-w-md">
                <div>
                  <p className="font-display text-3xl md:text-4xl font-black" style={{ color: RED }}>
                    21
                  </p>
                  <p className="text-xs text-white/70 mt-1">Avg. days to close</p>
                </div>
                <div>
                  <p className="font-display text-3xl md:text-4xl font-black" style={{ color: RED }}>
                    $0
                  </p>
                  <p className="text-xs text-white/70 mt-1">Down for VA / USDA</p>
                </div>
                <div>
                  <p className="font-display text-3xl md:text-4xl font-black" style={{ color: RED }}>
                    10K+
                  </p>
                  <p className="text-xs text-white/70 mt-1">Families served</p>
                </div>
              </div>
            </div>

            {/* Right side intentionally empty, lets the family photo breathe on desktop */}
            <div className="hidden md:block" />
          </div>
        </div>
      </div>
    </section>
  );
}
